<script>
    import journal from "../../stores/journal.js";
    import Scroll from "../windows/Scroll.svelte";

    export let window;

    $: current = $journal.all[$journal.indexForCurrent];
</script>

{#if current}
    <Scroll isFocused={window.isFocused}>
        <h3>Day {current.day}</h3>
        <p>{current.note}</p>
    </Scroll>
{:else}
    <div>
        <p>Sharpening a pencil...</p>
    </div>
{/if}

<style>
    div {
        padding: var(--chrome-depth);
    }
</style>
